<template>
  <div class="card-other-container">
    <a-card :bordered="false" class="header-solid h-full card-profile-information staff-info-card"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px', height: '100%', display: 'flex', flexDirection: 'column' }"
      :headStyle="{ paddingRight: 0 }" style="height: 500px">
      <div class="card-other-content">
        <div class="emergency-header-row d-flex align-items-center justify-content-between mt-12 mb-16 font-web">
          <div class="mt-20 card-custom-header">
            <div class="header-icon-box icon-emergency">
              <a-icon type="alert" />
            </div>
            <div class="header-text-group">
              <h5 class="header-title font-web m-0">Emergency</h5>
              <span class="header-subtitle font-web">ข้อมูลติดต่อกรณีฉุกเฉิน</span>
            </div>
          </div>
          <div class="emergency-updated-badge font-web">
            <a-icon type="clock-circle" class="mr-10" />
            <span class="emergency-updated-text">
              Update at {{ formatUpdatedAt(emergencyUpdatedDate) }}
            </span>
          </div>
        </div>
        <a-descriptions class="mt-20 mb-10" title="" :column="1">
          <a-descriptions-item label="Address">
            <span class="text-dark address-text">{{ emergencyDisplay.personalAddress || '-' }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="Personal phone number">
            <span class="text-dark">{{ emergencyDisplay.personalPhone || '-' }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="Emergency contact">
            <div v-if="hasEmergencyContact" class="emergency-contact-block">
              <div class="emergency-contact-row">
                <span class="text-muted">Emergency phone ::</span> <span class="text-dark">{{ emergencyDisplay.emergencyPhone || '-' }}</span>
              </div>
              <div class="emergency-contact-row mt-6">
                <span class="text-muted">Relation ::</span> <span class="text-dark">{{ emergencyDisplay.emergencyRelation || '-' }}</span>
              </div>
              <div class="emergency-contact-row mt-6">
                <span class="text-muted">Emergency Address ::</span> <span class="text-dark">{{ emergencyDisplay.emergencyAddress || '-' }}</span>
              </div>
            </div>
            <span v-else class="text-dark">-</span>
          </a-descriptions-item>
          <a-descriptions-item v-if="emergencyDisplay.personalLine" label="Line contact">
            <span class="text-dark">{{ emergencyDisplay.personalLine }}</span>
          </a-descriptions-item>
        </a-descriptions>
        <hr class="my-15" />
        <div v-if="dataProfileChief.length != 0 || dataProfileManage.length != 0">
          <h6 class="font-semibold mt-10 mb-20">Executive</h6>
          <a-descriptions class="mb-10" title="" :column="1">
            <a-descriptions-item label="">
              <p class="mt-0 mb-5 text-muted">
                Chief position :
              </p>
              <p class="mt-5 mb-0 text-dark">{{ isEmptyObjUI(dataProfileChief[0]) ? '' : dataProfileChief[0].position }}
              </p>
              <p class="font-web mt-5 mb-0 text-dark">{{ isEmptyObjUI(dataProfileChief[0]) ? '' :
                dataProfileChief[0].position_thai }}</p>
            </a-descriptions-item>
            <a-descriptions-item label="">
              <p class="mt-0 mb-5 text-muted">
                Management position :
              </p>
              <p class="mt-5 mb-0 text-dark">{{ isEmptyObjUI(dataProfileManage[0]) ? '' :
                dataProfileManage[0].management }}</p>
              <p class="font-web mt-5 mb-0 text-dark">{{ isEmptyObjUI(dataProfileManage[0]) ? '' :
                dataProfileManage[0].management_thai }}</p>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>

      <!-- Card Footer (Bottom Right Button) -->
      <div v-if="canUpdateEmergency" class="card-other-footer">
        <a-button type="primary" class="btn-update-emergency" @click="openModal">
          <a-icon type="edit" class="mr-5" />
          Update Emergency Contact
        </a-button>
      </div>
    </a-card>

    <!-- Drawer Component for Update Emergency Contact -->
    <drawer-emergency-contact :visible="isModalVisible" :initial-data="emergencyDisplay"
      :data-base-profile="dataOther" :data-profile-manage="dataProfileManage" @close="handleCloseModal"
      @save="handleSaveEmergencyContact" />
  </div>
</template>

<script>
import moment from 'moment';
import DrawerEmergencyContact from './drawerEmergencyContact.vue';

export default {
  name: 'CardOther',
  components: {
    DrawerEmergencyContact,
  },
  props: {
    dataOther: {
      type: Array,
      default: () => [],
    },
    dataProfileChief: {
      type: Array,
      default: () => [],
    },
    dataProfileManage: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isModalVisible: false,
      emergencyUpdatedDate: new Date(),
      emergencyDisplay: {
        code: '',
        personalAddress: '',
        personalPhone: '',
        emergencyPhone: '',
        emergencyRelation: '',
        emergencyAddress: '',
        personalLine: '',
      },
    };
  },
  computed: {
    hasEmergencyContact() {
      return !!(
        this.emergencyDisplay.emergencyPhone ||
        this.emergencyDisplay.emergencyRelation ||
        this.emergencyDisplay.emergencyAddress
      );
    },
    canUpdateEmergency() {
      const roles = (this.$store && this.$store.state && this.$store.state.role && this.$store.state.role.RulesUser && this.$store.state.role.RulesUser.roles) || [];
      return roles.includes('staff') || roles.includes('faculty') || roles.includes('pc_lecturers');
    },
  },
  watch: {
    dataOther: {
      deep: true,
      handler() {
        this.initProfileData();
      },
    },
  },
  mounted() {
    this.initProfileData();
  },
  methods: {
    initProfileData() {
      if (this.dataOther && this.dataOther.length > 0) {
        this.applyEmergencyData(this.dataOther[0]);
      }
    },
    applyEmergencyData(data) {
      if (!data) return;

      if (data.code) {
        this.emergencyDisplay.code = data.code;
      }

      // Address: ใช้ 'adress' (หรือ fallback 'personalAddress', 'address')
      const addr = data.adress !== undefined && data.adress !== null && data.adress !== ''
        ? data.adress
        : (data.personalAddress || data.address);
      if (addr !== undefined && addr !== null && addr !== '') {
        this.emergencyDisplay.personalAddress = addr;
      }

      // Personal phone number: ใช้ 'emergency_call' (หรือ fallback 'personalPhone', 'telephone')
      const phone = data.emergency_call !== undefined && data.emergency_call !== null && data.emergency_call !== ''
        ? data.emergency_call
        : (data.personalPhone || data.telephone);
      if (phone !== undefined && phone !== null && phone !== '') {
        this.emergencyDisplay.personalPhone = this.formatThaiPhone(phone);
      }

      // Emergency contact: split emergency_name ด้วย #
      // emergency_name[1] -> Emergency phone
      // emergency_name[0] -> Relation
      // emergency_name[2] -> Emergency Address
      if (data.emergency_name) {
        let parts = [];
        if (Array.isArray(data.emergency_name)) {
          parts = data.emergency_name;
        } else if (typeof data.emergency_name === 'string') {
          parts = data.emergency_name.split('#').map(s => s.trim());
        }
        if (parts[0] !== undefined) {
          this.emergencyDisplay.emergencyRelation = parts[0];
        }
        if (parts[1] !== undefined) {
          this.emergencyDisplay.emergencyPhone = this.formatThaiPhone(parts[1]);
        }
        if (parts[2] !== undefined) {
          this.emergencyDisplay.emergencyAddress = parts[2];
        }
      } else {
        if (data.emergencyRelation !== undefined) {
          this.emergencyDisplay.emergencyRelation = data.emergencyRelation;
        }
        if (data.emergencyPhone !== undefined) {
          this.emergencyDisplay.emergencyPhone = this.formatThaiPhone(data.emergencyPhone);
        }
        if (data.emergencyAddress !== undefined) {
          this.emergencyDisplay.emergencyAddress = data.emergencyAddress;
        }
      }

      const updateDate = data.emergency_updated_at || data.updated_at || data.date_update || data.last_update;
      if (updateDate) {
        this.emergencyUpdatedDate = updateDate;
      }
    },
    isEmptyObjUI(obj) {
      return !obj || Object.keys(obj).length === 0;
    },
    openModal() {
      this.isModalVisible = true;
      this.$emit('update-emergency');
    },
    handleCloseModal() {
      this.isModalVisible = false;
    },
    handleSaveEmergencyContact(savedData) {
      if (!savedData) return;

      // 1. อัปเดตในของเดิม (dataOther[0])
      if (this.dataOther && this.dataOther.length > 0) {
        Object.assign(this.dataOther[0], savedData);
      }

      // 2. ปรับการแสดงผล
      this.applyEmergencyData(savedData);

      if (savedData.personalLine !== undefined) {
        this.emergencyDisplay.personalLine = savedData.personalLine;
      }

      // 3. Update timestamp
      const updatedAt = savedData.updated_at || savedData.emergency_updated_at || new Date();
      this.emergencyUpdatedDate = updatedAt;

      this.$emit('save-emergency', savedData);
    },
    formatThaiPhone(val) {
      if (!val) return '';
      const numbers = String(val).replace(/\D/g, '').slice(0, 10);
      if (numbers.length <= 3) {
        return numbers;
      }
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    },
    isValidThaiPhone(phone) {
      if (!phone) return false;
      const raw = phone.replace(/\D/g, '');
      return raw.length === 10 && raw.startsWith('0');
    },
    formatUpdatedAt(date) {
      if (!date) return '-';
      const m = this.moment ? this.moment(date) : moment(date);
      return m.isValid() ? m.format('DD / MMMM / YYYY HH:mm') : '-';
    },
  },
};
</script>

<style lang="scss" scoped>
.card-other-container {
  height: 100%;

  ::v-deep .ant-descriptions-item-content {
    line-height: 1.65;
    word-break: break-word;
  }

  ::v-deep .ant-descriptions-item-label {
    line-height: 1.65;
  }
}

.staff-info-card {
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.07);
  }
}

.emergency-contact-block {
  line-height: 1.65;
}

.emergency-contact-row {
  line-height: 1.65;
}

.address-text {
  line-height: 1.65;
  word-break: break-word;
}

.card-other-content {
  flex: 1 1 auto;
}

.card-custom-header {
  display: flex;
  align-items: center;
}

.header-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  margin-right: 12px;
  flex-shrink: 0;
}

.icon-emergency {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #ef4444;
}

.header-text-group {
  display: flex;
  flex-direction: column;
}

.header-title {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.25;
}

.header-subtitle {
  font-size: 11.5px;
  color: #8f9bb3;
  margin-top: 1px;
}

.emergency-updated-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  font-size: 11.5px;
  color: #64748b;
}

.emergency-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.emergency-updated-text {
  font-size: 11.5px;
  color: #64748b;
}

.card-other-footer {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 16px;
}

.btn-update-emergency {
  background-color: #5832e5;
  border-color: #5832e5;
  color: #ffffff;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.btn-update-emergency:hover,
.btn-update-emergency:focus,
.btn-update-emergency:active {
  background-color: #4825d4;
  border-color: #4825d4;
  color: #ffffff;
}
</style>
